// extracted by mini-css-extract-plugin
export default {"title":"Title_title__E23Cr","titleDark":"Title_titleDark__YfVdY","titleLight":"Title_titleLight__cOspb"};